(() => {
  function positionGuide(guide) {
    const stage = guide.parentElement;
    const video = stage.querySelector('video');
    if (!video) return;
    const width = stage.clientWidth;
    const height = stage.clientHeight;
    if (!width || !height) return;
    const videoWidth = video.videoWidth || 4;
    const videoHeight = video.videoHeight || 3;
    const scale = Math.min(width / videoWidth, height / videoHeight);
    guide.style.width = `${Math.max(0, Math.floor(videoWidth * scale) - 24)}px`;
    guide.style.height = `${Math.max(0, Math.floor(videoHeight * scale) - 24)}px`;
  }
  function init() {
    document.querySelectorAll('[data-kob-two-zone-guide]').forEach((guide) => {
      if (guide.dataset.guideReady) return;
      guide.dataset.guideReady = 'true';
      const video = guide.parentElement.querySelector('video');
      if (!video) return;
      const update = () => positionGuide(guide);
      video.addEventListener('loadedmetadata', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(guide.parentElement);
      else window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
